import { useBaseStore } from "@store/base";
import { computed } from "vue";

export default function () {
  const base = useBaseStore();
  const pageLoading = computed(() => base.pageLoading);
  const setLoadingState = (status) => {
    base.setPageLoading(status);
  };
  return { pageLoading, setLoadingState };
}
